var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Suspense } from 'react';
import { ViewerScriptWrapper } from '@wix/native-components-infra';
import { listenToHeightChanges } from 'wix-height-updater';
import { ErrorBoundary } from './react/ErrorBoundary';
import { WixSDK } from './react/SDK/SDKRenderProp';
import WidgetWrapper from './WidgetWrapper';
import { createControllers, initAppForPageWrapper } from './viewerScript.js';
import { WixSDKProvider } from './react/SDK/WixSDKProvider';
// TODO: fill overrides and whatnot from santawrapper
export var createEditorAppForWixSDK = function (_a) {
    var UserComponent = _a.UserComponent, userController = _a.userController, customInitAppForPage = _a.customInitAppForPage, name = _a.name, sentryConfig = _a.sentryConfig, experimentsConfig = _a.experimentsConfig, translationsConfig = _a.translationsConfig, defaultTranslations = _a.defaultTranslations, projectName = _a.projectName, biConfig = _a.biConfig, biLogger = _a.biLogger, sdk = _a.sdk, stylesParams = _a.stylesParams, wrapperOptions = _a.wrapperOptions, appDefinitionId = _a.appDefinitionId, componentId = _a.componentId, optionalDeps = _a.optionalDeps, prepopulatedData = _a.prepopulatedData;
    var WithComponent = WidgetWrapper(optionalDeps, UserComponent, {
        name: name,
        Wix: sdk.Wix,
        sentryConfig: null,
        isEditor: true,
        stylesParams: stylesParams,
    });
    return ViewerScriptWrapper(WithComponent, __assign({ viewerScript: {
            createControllers: createControllers(optionalDeps, userController, translationsConfig, experimentsConfig, defaultTranslations, biConfig, biLogger, projectName, appDefinitionId, componentId, prepopulatedData),
            initAppForPage: initAppForPageWrapper({
                initAppForPage: customInitAppForPage,
                defaultTranslations: defaultTranslations,
                translationsConfig: translationsConfig,
                sentryConfig: sentryConfig,
                experimentsConfig: experimentsConfig,
                inEditor: true,
                projectName: projectName,
                biLogger: biLogger,
                biConfig: biConfig,
                appName: null,
                optionalDeps: optionalDeps,
                prepopulatedData: prepopulatedData,
            }),
        }, Wix: sdk.Wix, widgetConfig: {
            widgetId: componentId,
            getAllPublicData: true,
        } }, (wrapperOptions !== null && wrapperOptions !== void 0 ? wrapperOptions : {})));
};
var EditorAppWithCreator = /** @class */ (function (_super) {
    __extends(EditorAppWithCreator, _super);
    function EditorAppWithCreator(props) {
        var _this = _super.call(this, props) || this;
        var EditorAppComponent = null;
        if (props.sdk.Wix) {
            EditorAppComponent = createEditorAppForWixSDK(props);
            // Just to verify we are not exposing it.
        }
        else if (props.sdk.editorSDK) {
            throw new Error('Editor App does not support editorSDK');
        }
        _this.state = {
            EditorAppComponent: EditorAppComponent,
        };
        return _this;
    }
    EditorAppWithCreator.prototype.render = function () {
        var EditorAppComponent = this.state.EditorAppComponent;
        if (!EditorAppComponent) {
            return null;
        }
        return React.createElement(EditorAppComponent, __assign({}, this.props));
    };
    return EditorAppWithCreator;
}(React.Component));
export default (function (props) {
    return (React.createElement(Suspense, { fallback: React.createElement("div", null, "Loading...") },
        React.createElement(WixSDKProvider, null,
            React.createElement(WixSDK, null, function (sdk) {
                listenToHeightChanges(window.Wix, window);
                if (!props.sentryConfig) {
                    return (React.createElement(ErrorBoundary, { handleException: function (error) { return console.log(error); } },
                        React.createElement(EditorAppWithCreator, __assign({ sdk: sdk }, props))));
                }
                var Wix = sdk
                    ? sdk.Wix
                    : null;
                if (Wix) {
                    window.Sentry.configureScope(function (scope) {
                        scope.setTag('msid', Wix.Utils.getInstanceValue('metaSiteId'));
                        scope.setTag('environment', 'Editor');
                        scope.setUser({
                            id: Wix.Utils.getInstanceValue('uid'),
                        });
                    });
                }
                return (React.createElement(ErrorBoundary, { handleException: window.Sentry.captureException },
                    React.createElement(EditorAppWithCreator, __assign({ sdk: sdk }, props))));
            }))));
});
//# sourceMappingURL=EditorAppWrapper.js.map